import { requireEl } from './dom';
import { initVisitCounters } from './visitors';

const form = requireEl<HTMLFormElement>('upload-form');
const fileInput = requireEl<HTMLInputElement>('file');
const drop = requireEl<HTMLElement>('drop');
const status = requireEl<HTMLElement>('status');

function setStatus(text: string, ok = false): void {
  status.textContent = text;
  status.classList.toggle('ok', ok);
}

async function submitFile(file: File): Promise<void> {
  const data = new FormData();
  data.append('file', file);
  setStatus('загрузка…');
  try {
    const r = await fetch('/api/upload', { method: 'POST', body: data });
    const payload = await r.json().catch(() => ({}));
    if (!r.ok) {
      setStatus(typeof payload.error === 'string' ? payload.error : `ошибка ${r.status}`);
      return;
    }
    setStatus(`отправлено · id ${payload.id} · на модерации`, true);
    form.reset();
  } catch {
    setStatus('сеть недоступна');
  }
}

form.addEventListener('submit', e => {
  e.preventDefault();
  const file = fileInput.files?.[0];
  if (file) void submitFile(file);
});

drop.addEventListener('dragover', e => {
  e.preventDefault();
  drop.classList.add('hover');
});
drop.addEventListener('dragleave', () => drop.classList.remove('hover'));
drop.addEventListener('drop', e => {
  e.preventDefault();
  drop.classList.remove('hover');
  const file = e.dataTransfer?.files?.[0];
  if (file) {
    fileInput.files = e.dataTransfer!.files;
    void submitFile(file);
  }
});

initVisitCounters();
